/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Legends_ScopeInputs */

const en_directory_hubs_legends_scope = /** @type {(inputs: Directory_Hubs_Legends_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All-time ranking`)
};

const zh_directory_hubs_legends_scope = /** @type {(inputs: Directory_Hubs_Legends_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`历史总榜`)
};

/**
* | output |
* | --- |
* | "All-time ranking" |
*
* @param {Directory_Hubs_Legends_ScopeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_legends_scope = /** @type {((inputs?: Directory_Hubs_Legends_ScopeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Legends_ScopeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_legends_scope(inputs)
	return zh_directory_hubs_legends_scope(inputs)
});
export { directory_hubs_legends_scope as "directory.hubs.legends.scope" }